export const optionsMap = {
    Documentação: [
        {
            title: 'Documentações',
            value: 'documentation'
        },
        {
            title: 'Documentações de Projeto',
            value: 'projectdocumentation'
        },
        {
            title: 'Comunicados',
            value: 'announcements'
        }
    ],
    Contratualização: [
        {
            title: 'Contratualização',
            value: 'contractualizations'
        },
        {
            title: 'Unidades',
            value: 'units'
        }
    ],
    Organização: [
        {
            title: 'Grupo Gestor',
            value: 'principals'
        },
        {
            title: 'Organograma',
            value: 'organizationalchart'
        },
        {
            title: 'Carta de Serviço',
            value: 'servicelatter'
        },
        {
            title: 'Patrimônio',
            value: 'properties'
        },
    ],
    'Recursos Humanos': [
        {
            title: 'Colaboradores',
            value: 'employees'
        },
        {
            title: 'Folha de Pagamento',
            value: 'employeepayments'
        },
        {
            title: 'Ficha Salarial',
            value: 'individualemployeepayment'
        },
        {
            title: 'Processos Seletivos',
            value: 'selectionprocess'
        },
        {
            title: 'Plano de cargos e salários',
            value: 'positionsplan'
        }
    ],
    Demonstrativos: [
        {
            title: 'Relatórios',
            value: 'general'
        },
        {
            title: 'Parecer',
            value: 'report'
        },
        {
            title: 'Físico-Financeiro',
            value: 'phisic_finance'
        },
        {
            title: 'Balanço',
            value: 'balance'
        }
    ],
    Finanças: [
        {
            title: 'Resumo',
            value: 'resume'
        },
        {
            title: 'Extrato',
            value: 'history'
        }
    ],
    'Editais e Contratos': [
        {
            title: 'Processos',
            value: 'processes'
        },
        {
            title: 'Contratos',
            value: 'contracts'
        },
        {
            title: 'Editais',

            value: 'editals'
        }
    ],
    Qualificação: [],
    Indicadores: [],
    'Escala Médica': [],
    'Processos Seletivos': [],
    Emendas: []
};
